import type { MouseEvent } from "react"
import { toast as sonnerToast } from "sonner"

import { Toaster as SonnerToaster } from "@/components/ui/sonner"
import { HAWK_TOAST_TEST_ID_PREFIX } from "@/hooks/use-toast"

function dismissToastOnSurfaceClick(event: MouseEvent<HTMLDivElement>) {
  const target = event.target
  if (!(target instanceof Element)) {
    return
  }
  if (target.closest("button, a, [role='button'], [data-button]")) {
    return
  }

  const toastElement = target.closest<HTMLElement>("[data-sonner-toast]")
  const testId = toastElement?.getAttribute("data-testid")
  if (!testId?.startsWith(HAWK_TOAST_TEST_ID_PREFIX)) {
    return
  }

  sonnerToast.dismiss(testId.slice(HAWK_TOAST_TEST_ID_PREFIX.length))
}

export function Toaster() {
  return (
    <div onClick={dismissToastOnSurfaceClick}>
      <SonnerToaster
        closeButton
        duration={6000}
        position="bottom-right"
        swipeDirections={["right"]}
      />
    </div>
  )
}
